import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/static/locked-icon.svg'
import _imports_1 from '../assets/static/calendar-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-999d0fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-progress-container" }
const _hoisted_2 = {
  key: 0,
  class: "box-menu"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "circular-progress",
  ref: "circularProgressBar"
}
const _hoisted_6 = { class: "inner-circle" }
const _hoisted_7 = {
  key: 0,
  class: "open-lock"
}
const _hoisted_8 = {
  class: "icon",
  src: _imports_0,
  alt: "Locked icon"
}
const _hoisted_9 = {
  class: "icon",
  src: _imports_1,
  alt: "Calendar icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.checked)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            name: "checkbox",
            checked: _ctx.checked,
            tabindex: "-1"
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.blocked && !_ctx.upcoming)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
            [_vShow, _ctx.blocked && !_ctx.upcoming]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
            [_vShow, _ctx.upcoming]
          ])
        ], 512))
  ]))
}